/* import __COLOCATED_TEMPLATE__ from './bandpass-inductor-gain.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();